import { useEffect, useRef, useCallback, Dispatch, SetStateAction } from "react";
import { useMap } from "react-leaflet";
import L from 'leaflet';
import { GeoJSONFeatureCollection, MapFilterData, salesFilterData } from "pages/sales-forecast/salesForecastTypes";

interface LegendProps {
  mergedGeoJSON: GeoJSONFeatureCollection;
  extremes: { min: number, max: number }

}

const Legend: React.FC<LegendProps> = ({ mergedGeoJSON, extremes}) => {
  const map = useMap();
  const legendRef = useRef<HTMLDivElement | null>(null);

  const colors = [
    '#7B2CBF',  
    '#5a189a',  
    '#3c096c',  
    '#240046',  
  ];

  const getColorForDensity = (density: number, thresholds: number[]) => {
    for (let i = 0; i < thresholds.length - 1; i++) {
      if (density >= thresholds[i] && density < thresholds[i + 1]) {
        return colors[i];
      }
    }
    return colors[colors.length - 1];
  };



  const updateLegend = useCallback((legend: HTMLDivElement) => {
    const { min, max } = extremes;
    // const itemCount = mergedGeoJSON.features.length;

    // const thresholdCount = itemCount < 5 ? Math.min(itemCount, 3) : 4;
    
    // // Handle case when thresholdCount is 1 or minValue === maxValue
    // const thresholds = thresholdCount === 1 || min === max
    //   ? [min]
    //   : Array.from({ length: thresholdCount }, (_, i) => {
    //       return min+ ((max - min) / (thresholdCount - 1)) * i;
    //     });
   
let thresholds
        if (min === max) {
          thresholds = [min];  // Only one threshold in this case
        } else {
          thresholds = Array.from({ length: 4 }, (_, i) => {
            return min + ((max - min) / 3) * i;
          });
        }




    const labels = [];
    labels.push(`<div><p class='legend-title'>Forecast Amount</p></div>`);

    for (let i = 0; i < thresholds.length - 1; i++) {
      const firstNo = formatNumber(thresholds[i]);
      const secondNo = formatNumber(thresholds[i + 1]);
      const color = getColorForDensity(thresholds[i + 1], thresholds);
      labels.push(
        `<i style="background-color:${color}"></i> $${firstNo} - $${secondNo}`
      );
    }

    labels.push(
      `<i style="background-color:${getColorForDensity(thresholds[thresholds.length - 1] + 1, thresholds)}"></i> $${formatNumber(thresholds[thresholds.length - 1])}+`
    );

    legend.innerHTML = labels.join("<br>");
  }, [mergedGeoJSON]);

  useEffect(() => {
    const legend = new L.Control({ position: 'bottomright' });

    legend.onAdd = () => {
      const div = L.DomUtil.create('div', 'info legend') as HTMLDivElement;
      legendRef.current = div;
      updateLegend(div);
      return div;
    };

    legend.addTo(map);

    return () => {
      map.removeControl(legend);
    };
  }, [map, updateLegend]);

  return null;
};

export default Legend;

const formatNumber = (number: number): string => {
  const numberStr = number.toFixed();

  if (numberStr.length > 6) {
    return parseInt(numberStr.slice(0, -6)).toLocaleString('en-US') + 'M';
  } else if (numberStr.length > 3) {
    return parseInt(numberStr.slice(0, -3)).toLocaleString('en-US') + 'K';
  }
  return number.toLocaleString('en-US'); 
};
